import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Payroll / paycheck APIs (Points 14 & 15, Mudassir Jun-19).
const PayrollService = {
  // HR/Admin: create a paycheck for one employee + pay period.
  // Backend pulls in approved unpaid leave + approved bonuses and returns the
  // saved paycheck with gross/deductions/net calculated.
  createPaycheck: async (payload) => {
    const response = await axiosInstance.post(API.payroll.create, payload);
    return response.data;
  },

  // HR/Admin: pay history for one employee. Returns
  // { employeeId, cumulativeGrossPay, cumulativeNetPay, paycheckCount, paychecks: [] }.
  getEmployeePayHistory: async (employeeId) => {
    const response = await axiosInstance.get(API.payroll.getByEmployee(employeeId));
    return response.data;
  },

  // Employee: my own pay history (same shape, read-only).
  getMyPayHistory: async () => {
    const response = await axiosInstance.get(API.payroll.me);
    return response.data;
  },
};

export default PayrollService;
